import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

window.toastr = toastr
